<template>
  <div class="bg-white rounded-2xl shadow-md p-6">
    <Loading v-if="loading" />
    <Table v-else-if="businessVerticals.length" :columns="columns" :data="businessVerticals" />
    <p v-else class="text-center text-sm text-gray-500 py-4">{{ t("no_business_vertical") }}</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { useI18n } from "vue-i18n";
import { Loading, Table } from "@estaly/ui";

export default {
  components: { Loading, Table },

  props: {
    storeId: { type: Number, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      loading: true,
      businessVerticals: [],
    };
  },

  computed: {
    columns() {
      return [{ label: this.t("vertical"), field: "translatedCategory" }];
    },
  },

  async mounted() {
    try {
      this.businessVerticals = (await this.fetchStoreVerticals(this.storeId)) || [];
    } finally {
      this.loading = false;
    }
  },

  methods: {
    ...mapActions("businessVerticals", ["fetchStoreVerticals"]),
  },
};
</script>

<i18n src="./StoreBusinessVerticals.i18n.json"></i18n>
